import { render, staticRenderFns } from "./AnnualReturnsDetails.vue?vue&type=template&id=75dc6822&scoped=true&"
import script from "./AnnualReturnsDetails.vue?vue&type=script&lang=js&"
export * from "./AnnualReturnsDetails.vue?vue&type=script&lang=js&"
import style0 from "./AnnualReturnsDetails.vue?vue&type=style&index=0&id=75dc6822&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "75dc6822",
  null
  
)

export default component.exports